import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/users';
import { IdType, ResultState } from '@rootCommon/types/common';
import { User } from '@rootCommon/types/user';
import { PermissionTemplateCode } from '@rootCommon/types/permission';

type Action = ActionType<typeof actions>;
type OwnState = { selectedGroupId: IdType | null; selectedPermissionCode: PermissionTemplateCode | null };
export type UserState = ResultState<User | null> & OwnState;

const initState: UserState = {
  data: null,
  loading: false,
  error: null,
  selectedGroupId: null,
  selectedPermissionCode: null,
};

export const usersItemReducer = (state = initState, action: Action): UserState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchUser.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchUser.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchUser.failure):
      return { ...state, loading: false, error: action.payload };

      // create
    case getType(actions.createUser.request):
      return { ...state, loading: true, error: null };
    case getType(actions.createUser.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.createUser.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateUser.request):
      return { ...state, loading: true, error: null };
    case getType(actions.updateUser.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.updateUser.failure):
      return { ...state, loading: false, error: action.payload };

      // delete
    case getType(actions.deleteUsers.request):
      return { ...state, loading: true, error: null };
    case getType(actions.deleteUsers.success):
      return { ...state, loading: false, data: null };
    case getType(actions.deleteUsers.failure):
      return { ...state, loading: false, error: action.payload };

      // groupId
    case getType(actions.setUserGroupId):
      return { ...state, selectedGroupId: action.payload };

      // permissionType Id
    case getType(actions.setUserPermissionCode):
      return { ...state, selectedPermissionCode: action.payload };

    case getType(actions.resetUserItemData): {
      return initState;
    }

    // default
    default:
      return state;
  }
};

export default usersItemReducer;
